import {
  CompanyCalendarGigDto,
  CompanyCalendarItemsDtoV2,
} from "model/Calendar";

type calendarAction =
  | {
      type: "UPDATE_WEEKLY_CALENDAR";
      payload: CompanyCalendarGigDto[];
    }
  | {
      type: "UPDATE_OVERVIEW_WEEK_CALENDAR";
      payload: CompanyCalendarGigDto[];
    }
  | {
      type: "UPDATE_WEEKLY_CALENDAR_V2";
      payload: CompanyCalendarItemsDtoV2[];
    }
  | {
      type: "UPDATE_OVERVIEW_WEEK_CALENDAR_V2";
      payload: CompanyCalendarItemsDtoV2[];
    }
  | { type: "SET_IS_LOADING"; payload: boolean };

export type CalendarActions = calendarAction;

export type CalendarState = {
  currentWeek: CompanyCalendarGigDto[];
  overviewWeek: CompanyCalendarGigDto[];
  currentWeekV2: CompanyCalendarItemsDtoV2[];
  overviewWeekV2: CompanyCalendarItemsDtoV2[];
  isLoading: boolean;
};

export const calendarInitState: CalendarState = {
  currentWeek: [],
  overviewWeek: [],
  currentWeekV2: [],
  overviewWeekV2: [],
  isLoading: false,
};

export const calendarStateReducer = (
  state: CalendarState,
  action: CalendarActions
): CalendarState => {
  switch (action.type) {
    case "UPDATE_WEEKLY_CALENDAR": {
      return { ...state, currentWeek: action.payload };
    }

    case "UPDATE_OVERVIEW_WEEK_CALENDAR": {
      return { ...state, overviewWeek: action.payload };
    }

    case "UPDATE_WEEKLY_CALENDAR_V2": {
      return { ...state, currentWeekV2: action.payload };
    }

    case "UPDATE_OVERVIEW_WEEK_CALENDAR_V2": {
      return { ...state, overviewWeekV2: action.payload };
    }

    case "SET_IS_LOADING": {
      return { ...state, isLoading: action.payload };
    }
    default: {
      throw new Error(`Unhandled action type: ${action}`);
    }
  }
};
